import {convertFromHTML, ContentState, EditorState} from 'draft-js'

const htmlToEditorState = (html: string): EditorState => {
  const contentBlock = convertFromHTML(html)
  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks,
    contentBlock.entityMap
  )
  return EditorState.createWithContent(contentState)
}

export default htmlToEditorState
